<template>
  <div
    id="app"
    :style="{
      marginTop: isHeader ? '64px' : '0px'
    }"
  >
    <custom-header v-if="isHeader"></custom-header>
    <router-view />
    <alert-popup :model="alertMessage" v-if="showAlert"></alert-popup>
    <div
      style="z-index: 9999 !important;"
      class="pos-fixed toast text-light padding-10 radius-30"
      v-if="showToast"
    >
      {{ toastMessage }}
    </div>
    <div
      style="z-index: 999999999;
                background-color: rgba(0, 0, 0, 0.8);
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;bottom: 0; display: flex;"
      v-if="scPending"
      class="align-ver center-ver center-hor"
      id="sc_won_fullscreen_popup"
    >
      <div
        style="display: flex; width: 100%; justify-content: end;padding-top: 20px; align-items: center; padding-right: 10px; height:20px"
        v-on:click="hidePopup()"
      >
        <img
          src="@/assets/close.svg"
          class="w10 pointer"
          v-on:click="hidePopup()"
          style="position: absolute; right: 20px"
        />
      </div>
      <div class="" style="color: white; font-size: 22px; margin-bottom: 25px;">
        Congratulations!
      </div>
      <div class="text-light" style="margin-bottom: 50px">
        You WON Scratch Card!
      </div>

      <div
        :style="{ background: bgTheme }"
        class="margin-bottom-15 pos-rel"
        style="width: 55vw; height: 55vw; border-radius: 20px;"
        @click="
          hidePopup();
          redirectTo('rewards');
        "
      >
        <img class="full-width opc-25" src="@/assets/sc-bg.svg" />
        <div
          class="radius50 pos-center-ver pos-abs pos-center-hor align-hor center-ver center-hor"
          style="height: 60px; width: 60px;"
          :style="{ background: darkerBg }"
        >
          <img class="w40 opc-80" src="@/assets/medal-white.svg" />
        </div>
      </div>
      <div
        class="text-center"
        style="border: 1px solid white; border-radius: 20px; height: 20px; padding: 5px 25px 5px 25px; color: white; line-height: 20px; margin: 40px 0; font-size: 14px; cursor: pointer;"
        @click="
          hidePopup();
          redirectTo('rewards');
        "
      >
        CLAIM
      </div>
    </div>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";
import Header from "@/components/header";
import AlertPopup from "@/components/alert";
import axios from "axios";
export default {
  name: "App",
  mixins: [globals],
  components: {
    "custom-header": Header,
    "alert-popup": AlertPopup
  },
  data() {
    return {
      sc_pending: false,
      headersSet: false
    };
  },
  computed: {
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },

    scPending: function() {
      return this.sc_pending && this.$store.state.show_sc;
    }
  },
  methods: {
    handleSDKMessage(event) {
      // if (event.origin !== "https://web-sdk.theflyy.com")
      //     return;
      if (event.data.share_buttons_visible == false) {
        this.$store.state.user.isShareButtonAvailable = false;
      } else if (typeof event.data.share_buttons_visible == "undefined") {
        this.$store.state.user.isShareButtonAvailable = true;
      } else {
        this.$store.state.user.isShareButtonAvailable = true;
      }
      if (this.$route.query.p_id) {
        var data = {};
        data.partner_id = this.$route.query.p_id;
        data.ext_user_token = this.$route.query.token;
        data.environment = this.$route.query.env;
        data.url = this.$route.query.redirect;
      } else {
        var data = null;
        try {
          data = JSON.parse(event.data);
          //console.log(data);
        } catch (e) {
          //console.log(event.data)
          //data = event.data;
          if (event.data.type !== "webpackOk" || event.type !== "webpackOk") {
            if (event.data.type !== "webPackOk") {
              data = event.data;
            }
          }
        }
      }
      if (data != null) {
        // The host posts this only once. Opening a game navigates away, so
        // coming back reloads the SDK with no init data; keep it for the session.
        try {
          var toSave = Object.assign({}, data);
          delete toSave.url;
          sessionStorage.setItem("flyy-sdk-init", JSON.stringify(toSave));
        } catch (e) {}
        var headers = {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Package-Name": data["package_name"],
          "X-SDK-Version-Code": data["sdk_version_code"],
          "X-SDK-Version-Name": data["sdk_version_name"],
          "X-App-Version-Code": data["app_version_code"],
          "X-App-Version-Name": data["app_version_name"],
          "X-Android-Id": data["android_id"],
          "X-GAID": data["gaid"],
          "X-App-Data": data["app_data"],
          "X-User-Token": data["user_token"],
          "X-Key": data["api_key"] || data["partner_id"],
          "X-Token": data["ext_user_token"]
        };
        if (data["Environment"]) {
          this.$store.state.environment = data["Environment"];
        } else {
          this.$store.state.environment = data["environment"];
        }
        if (data["theme_color_primary"]) {
          this.$store.state.bg_theme = data["theme_color_primary"];
        }
        if (data["ext_uid"]) {
          this.$store.state.user.ext_uid = data["ext_uid"];
        } else if (data["user_token"]) {
          this.$store.state.user.ext_uid = data["user_token"];
        }
        this.$store.state.partner = data["api_key"] || data["partner_id"];

        this.$store.dispatch("setHeaders", headers);
        //this.headersSet = true;
        this.loadDataFromCookie();
        this.checkPendingSC();
        //console.log("before url check env");
        if (data["url"]) {
          var url = data["url"];
          this.$store.state.screenOpened = url;
          delete data["url"];
          this.redirectTo(url);
        }
        //console.log("before url check env");
        if (data["url"]) {
          var url = data["url"];
          this.$store.state.screenOpened = url;
          delete data["url"];
          this.redirectTo(url);
        }
      }
    },
    hidePopup() {
      this.sc_pending = false;
      this.$store.state.show_sc = false;
    },
    checkPendingSC() {
      // console.log("created");
      var url =
        this.$store.getters.flyyDomain.replace("/api", "") +
        `/v1/${this.$store.state.partner}/partner_user/pending_rewards`;
      var headers = this.$store.getters.headers;

      var options = {
        headers: headers
      };

      axios
        .post(
          url,
          {
            mode: "no-cors"
          },
          options
        )
        .then(resp => {
          if (resp.status == 200) {
            this.sc_pending = resp.data.success;
          } else {
            console.log("Error fetching the pending sc data");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  beforeMount() {
    var self = this;
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem("flyy-sdk-init"));
    } catch (e) {}
    if (saved && !self.$store.state.user.ext_uid) {
      self.handleSDKMessage({ data: saved, type: "restore" });
    }
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, { once: true });
    } else {
      window.attachEvent(
        "onmessage",
        self.handleSDKMessage,
        { once: true },
        { once: true }
      );
    }

    // if (window.webkit) {
    document.getElementById("status-bar").style.display = "block";
    document.getElementById(
      "status-bar"
    ).style.backgroundColor = this.$store.state.bg_theme;
    // }
  },
  created() {
    var self = this;
    document.addEventListener("visibilitychange", self.closeAlert, false);
    window.addEventListener("locationchange", self.closeAlert, false);
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
  }
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #eeeeee;
  font-weight: 600;
  font-size: 15px;
}
b {
  font-weight: 900 !important;
}
</style>
